import React from "react";
import { styled } from "@mui/material";

// ✅ 체크박스를 감싸는 영역을 가로 중앙 정렬
const ContactAgree = styled("div")(() => ({
  maxWidth: "400px",
  margin: "50px auto 0 auto",
  display: "flex", // ✅ Flexbox 사용
  justifyContent: "center", // ✅ 가로 중앙 정렬
  alignItems: "center", // ✅ 수직 중앙 정렬
  "@media (max-width: 1000px)": {
    maxWidth: "320px",
    marginTop: "60px",
    whiteSpace: "nowrap",
  },
}));

const AgreeList = styled("ul")(() => ({
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex", // ✅ Flexbox 적용
  justifyContent: "center", // ✅ 가로 중앙 정렬
  alignItems: "center", // ✅ 수직 정렬

  "& li": {
    position: "relative",
    display: "flex", // ✅ 체크박스와 텍스트를 한 줄로 정렬
    alignItems: "center", // ✅ 수직 중앙 정렬
    gap: "10px", // ✅ 체크박스와 텍스트 간 간격 조정
    marginBottom: "14px",

    "& input": {
      position: "relative",
      width: "28px",
      height: "28px",
      cursor: "pointer",
    },

    "& label": {
      color: "#fff",
      fontSize: "16px",
      letterSpacing: "-1px",
      cursor: "pointer",
    },
  },

  "@media (max-width: 1000px)": {
    "& li label": {
      fontSize: "14px",
    },
  },
}));

interface Props {
  checked: boolean;
  onChange: () => void;
}

export const AgreementCheckbox: React.FC<Props> = ({ checked, onChange }) => (
  <ContactAgree>
    <AgreeList>
      <li>
        <input type="checkbox" id="agree1" checked={checked} onChange={onChange} />
        <label htmlFor="agree1">[필수] 개인정보 수집/이용에 동의합니다.</label>
      </li>
    </AgreeList>
  </ContactAgree>
);
